// 上传文件到S3
function uploadToS3({ blob, fileName, successFn, progressFn, errorFn, cropData }) {
  //const suffix = blob.type.split('/')[1]

  // const fileName = Math.random().toString(36).substr(2) + "." + suffix;

  const folderName = "orders";

  const bucket = "giftinone/" + folderName;
  const request = S3UploadObject(bucket, blob, fileName, cropData);

  request.on("httpUploadProgress", function (progress) {
    const percentage = Math.floor((progress.loaded / progress.total) * 100);
    if (progressFn) {
      progressFn(percentage);
    }
  });

  request.on("success", function () {
    const picurl =
      "https://static.giftinone.com/" + folderName + "/" + fileName;
    if (successFn) {
      successFn(picurl);
    }
  });

  request.on("error", function (err) {
    if (errorFn) {
      alert(
        `The error message ${JSON.stringify(
          err
        )}, please contact customer service`
      );
      errorFn();
    }
    request.send();
  });
}
/*common function*/
function S3UploadObject(temporaryBucket, file, fileName, cropData) {
  const spacesEndpoint = new AWS.Endpoint('s3-accelerate.amazonaws.com');
  const s3 = new AWS.S3({
    endpoint: spacesEndpoint,
    accessKeyId: 'AKIAQR47IXWA47U6COG2',
    secretAccessKey: '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',
    region: "us-west-1"
  });
  let metadata = {};
  if (cropData) {
    // 将 cropData 添加到 metadata
    metadata = {
      x: String(cropData.x),
      y: String(cropData.y),
      angle: String(cropData.angle),
      scaleX: String(cropData.scaleX),
      scaleY: String(cropData.scaleY),
      width: String(cropData.width),
      height: String(cropData.height),
      rotate: String(cropData.rotate),
      originalwidth: String(cropData.originalwidth),
      originalheight: String(cropData.originalheight),
      clockfilename: String(cropData.clockfilename),
    };
  }
  var params = {
    Bucket: temporaryBucket,
    Key: fileName,
    Body: file,
    ContentType: "image",
    ACL: "public-read",
    // 添加 metadata，用于给lambda传递参数
    Metadata: metadata,
    // 打未下单的标签，用于存储桶删除图片，以下是sdk v2版语法
    Tagging: 'orderNotPlaced'
  };
  var request = s3.putObject(params, function (err) {
    if (err)
      console.log(err)
  });
  request.on("httpUploadProgress", function (progress) {
  })
  request.on("success", function (response) {
  })
  request.on("error", function () {
    console.log("Ajax request failed...");
    request.send();
  })
  return request
}
